export const generateGuarantees = ({ paymentData }) => {
  try {
    const guaranteesAccepted = []

    if (
      paymentData.paymentOption === 'paymentPlan' &&
      +paymentData.totalDue >
        (+paymentData.travelCardAmount || 0) +
          (+paymentData.loyaltyPointsAmount || 0)
    ) {
      // Payment plans allow new or saved credit cards.
      return [
        {
          guaranteeTypeCode: 41,
          providerName: 'BookIt',
          paymentInfo: {
            provider:
              paymentData?.paymentCardOption === 'saved-card'
                ? {
                    guaranteeTypeCode: 5,
                    providerName: 'ekashu',
                    paymentCards: [
                      {
                        cardHolderName:
                          paymentData?.savedCardData?.customerNumber,
                        cardNumber: paymentData?.savedCardData?.reference,
                        seriesCode: paymentData?.savedCardSeriesCode || '',
                      },
                    ],
                  }
                : {
                    guaranteeTypeCode: 46,
                    providerName: 'preloadEkashu',
                    paymentInfo: {
                      saveCard: paymentData?.paymentCardOption !== 'saved-card',
                    },
                  },
          },
        },
      ]
    }

    if (
      paymentData?.paymentOption === 'creditCard' &&
      +paymentData.totalDue >
        (+paymentData.travelCardAmount || 0) +
          (+paymentData.loyaltyPointsAmount || 0)
    ) {
      if (paymentData?.paymentCardOption === 'saved-card') {
        guaranteesAccepted.push({
          guaranteeTypeCode: 5,
          providerName: 'ekashu',
          paymentCards: [
            {
              cardHolderName: paymentData?.savedCardData?.customerNumber,
              cardNumber: paymentData?.savedCardData?.reference,
              seriesCode: paymentData?.savedCardSeriesCode || '',
            },
          ],
        })
      } else {
        guaranteesAccepted.push({
          guaranteeTypeCode: 46,
          providerName: 'preloadEkashu',
          paymentInfo: {
            saveCard: !!paymentData?.saveCard,
          },
        })
      }
    }

    const includesNewCard =
      paymentData?.paymentOption === 'creditCard' &&
      paymentData?.paymentCardOption !== 'saved-card'

    if (
      paymentData.pointOption === 'loyaltyPoints' &&
      paymentData?.availableLoyaltyPoints
    ) {
      if (paymentData?.applyLoyaltyPoints) {
        const redemptionQuantity = Math.min(
          +paymentData.totalDue,
          +paymentData.loyaltyPointsAmount,
        )

        guaranteesAccepted.push({
          guaranteeTypeCode: 47,
          loyaltyRedemption: {
            redemptionQuantity,
          },
          calculateOnly: includesNewCard,
        })
      } else {
        const redemptionQuantity = Math.min(
          +paymentData.totalDue,
          +paymentData.availableLoyaltyPoints,
        )

        guaranteesAccepted.push({
          guaranteeTypeCode: 47,
          loyaltyRedemption: {
            redemptionQuantity,
          },
          calculateOnly: includesNewCard,
        })
      }
    }

    if (
      paymentData.pointOption === 'travelCard' &&
      paymentData?.travelCard?.balance
    ) {
      if (paymentData?.applyTravelCard) {
        const redemptionQuantity = Math.min(
          +paymentData.travelCardAmount,
          +paymentData.totalDue,
        )
        guaranteesAccepted.push({
          guaranteeTypeCode: 15,
          loyaltyRedemption: {
            redemptionQuantity,
          },
          paymentCards: [
            {
              seriesCode: paymentData.travelCardPin,
            },
          ],
          calculateOnly: includesNewCard,
        })
      } else {
        const redemptionQuantity = Math.min(
          +paymentData.travelCard.balance,
          +paymentData.totalDue,
        )
        guaranteesAccepted.push({
          guaranteeTypeCode: 15,
          loyaltyRedemption: {
            redemptionQuantity,
          },
          paymentCards: [
            {
              seriesCode: paymentData.travelCardPin,
            },
          ],
          calculateOnly: includesNewCard,
        })
      }
    }

    if (
      paymentData.pointOption?.includes('loyaltyPoints') &&
      paymentData.pointOption?.includes('travelCard') &&
      paymentData?.availableLoyaltyPoints &&
      paymentData?.travelCard?.balance
    ) {
      if (paymentData?.applyLoyaltyPoints && paymentData?.applyTravelCard) {
        const redemptionTravelCardQuantity = Math.min(
          +paymentData.totalDue,
          +paymentData.travelCardAmount,
        )

        guaranteesAccepted.push({
          guaranteeTypeCode: 15,
          loyaltyRedemption: {
            redemptionQuantity: redemptionTravelCardQuantity,
          },
          paymentCards: [
            {
              seriesCode: paymentData.travelCardPin,
            },
          ],
          calculateOnly: includesNewCard,
        })
        const afterRedemptionTravelCardQuantity =
          +paymentData.totalDue - redemptionTravelCardQuantity
        if (afterRedemptionTravelCardQuantity > 0) {
          const redemptionLoyaltyPointsQuantity = Math.min(
            +paymentData.loyaltyPointsAmount,
            +afterRedemptionTravelCardQuantity,
          )
          guaranteesAccepted.push({
            guaranteeTypeCode: 47,
            loyaltyRedemption: {
              redemptionQuantity: redemptionLoyaltyPointsQuantity,
            },
            calculateOnly: includesNewCard,
          })
        }
      } else {
        const redemptionTravelCardQuantity = Math.min(
          +paymentData.totalDue,
          +paymentData.travelCard.balance,
        )

        guaranteesAccepted.push({
          guaranteeTypeCode: 15,
          loyaltyRedemption: {
            redemptionQuantity: redemptionTravelCardQuantity,
          },
          paymentCards: [
            {
              seriesCode: paymentData.travelCardPin,
            },
          ],
          calculateOnly: includesNewCard,
        })
        const afterRedemptionTravelCardQuantity =
          +paymentData.totalDue - redemptionTravelCardQuantity
        if (afterRedemptionTravelCardQuantity > 0) {
          const redemptionLoyaltyPointsQuantity = Math.min(
            +paymentData.availableLoyaltyPoints,
            +afterRedemptionTravelCardQuantity,
          )
          guaranteesAccepted.push({
            guaranteeTypeCode: 47,
            loyaltyRedemption: {
              redemptionQuantity: redemptionLoyaltyPointsQuantity,
            },
            calculateOnly: includesNewCard,
          })
        }
      }
    }

    if (paymentData.paymentOption === 'payPal') {
      guaranteesAccepted.push({
        guaranteeTypeCode: 46,
        providerName: 'paypal',
        paymentInfo: paymentData.payPalResponse,
      })
    }

    return guaranteesAccepted
  } catch (err) {
    throw new Error(`Payment form error: ${err?.message || ''}.`)
  }
}
